<template>
  <base-list-table :data="completeList" :structure="structure" :refreshFunction="refreshPage" />
</template>

<script>
  import { useStore } from 'vuex';
  import { computed } from 'vue';
  export default {
    components: {},
    setup() {
      const store = useStore();

      function refreshPage(payload) {
        console.log(payload);
        store.dispatch('getCompleteUsersList', {
          user_type: 'Cliente',
          ...payload,
        });
      }

      const completeUserList = computed(() => store.getters.completeUsersList);

      const structure = {
        title: 'views.user.usersList',
        timeFields: [
          { label: 'views.timeEntries.creationDate', key: 'created_at' },
          { label: 'views.timeEntries.lastUpdate', key: 'updated_at' },
          { label: 'views.timeEntries.termsAndConditionsAcceptance', key: 'terms_and_conditions_timestamp' },
        ],
        creationLink: {
          title: 'consumers.newConsumer',
          namePath: 'menu.user.usersCreation',
        },
        data: [
          {
            title: 'user.name.first',

            fields: [
              {
                placeholder: '@',
                name: 'id',
                class: 'text-primary-400',
              },
              {
                name: 'name',
              },
            ],
            span: 1,
            link: { idField: 'id', path: '/user/users/:id' },
          },
          {
            title: 'user.name.second',

            field: 'surname',
            span: 1,
          },
          {
            title: 'user.cellphone',

            field: 'cellphone',
            span: 1,
          },
          {
            title: 'user.email',

            field: 'email',
            span: 2,
          },
          {
            title: 'user.notes',

            field: 'notes',
            span: 2,
          },
        ],
      };

      return {
        completeList: completeUserList,
        structure,
        refreshPage,
      };
    },
  };
</script>

<style></style>
